/**
 * The backend refuses to merge two different records from one CRM (they are merged in the CRM
 * instead) and says so with a message it has already localized, tagged with this code
 * (coffee: api/error_codes.py MERGE_REFUSED_SAME_CRM, surfaced as extensions.code by
 * server/graphql_errors.py safe_error_formatter).
 */
export const MERGE_REFUSED_SAME_CRM = 'MERGE_REFUSED_SAME_CRM';

type WithGraphQLErrors = {
  graphQLErrors?: ReadonlyArray<{ message: string; extensions?: Record<string, unknown> }>;
};

/**
 * What a failed merge toast should say: the server's own message when it refused the merge on
 * purpose, otherwise the caller's translated fallback. Network and internal errors never reach the
 * user as raw text.
 */
export function mergeFailureMessage(error: unknown, fallback: string): string {
  const refusal = (error as WithGraphQLErrors | null)?.graphQLErrors?.find(
    e => e.extensions?.code === MERGE_REFUSED_SAME_CRM,
  );
  return refusal?.message ?? fallback;
}
